'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class riskModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}

	getValue(name){
		switch(name){
			case 'b2_6_risk_probability':
				return this.getClassifValue(name, 'risk');
			case 'b2_6_risk_package':
			case 'wp_ids':
				return this.getClassifValue('wp_ids', 'wp');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
